import React from 'react';
import MaterialRadioGroup from '@mui/material/RadioGroup';
import type {RadioGroupProps as MaterialRadioGroupProps} from '@mui/material/RadioGroup';

export interface RadioGroupProps extends MaterialRadioGroupProps {}

export const RadioGroup = React.forwardRef<any, RadioGroupProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <MaterialRadioGroup
                ref={ref}
                {...props}
            >
                {children}
            </MaterialRadioGroup>
        );
    });

RadioGroup.displayName = 'RadioGroup';
